<template>
    <div>
        <div v-if="submitting" class="loading-overlay2">
            <div class="">
                <svg xmlns="http://www.w3.org/2000/svg" style="margin: auto; background: none; display: block;" width="50px" height="50px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                    <circle cx="50" cy="50" fill="none" stroke="#2e9bf0" stroke-width="10" r="35" stroke-dasharray="165 57">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.5s" values="0 50 50;360 50 50" keyTimes="0;1" />
                    </circle>
                </svg>
            </div>
        </div>
        <section class="checkout-nav-section">
            <div class="checkoutnav_wrap">
                <div class="checkoutnav_div">
                    <a href="#" class="link-block-73 w-inline-block"><img src="@/assets/images/Main_Logo.png" loading="lazy" sizes="84.03125px" srcset="@/assets/images/Logo-p-500.png 500w, @/assets/images/Logo-p-800.png 800w, @/assets/images/Main_Logo.png 1000w" alt="" class="image-487"></a>
                    <div class="checkoutnav_progressdiv">
                        <div class="progress_step_div"></div>
                        <div class="progress_step_div current"></div>
                        <div class="progress_step_div"></div>
                        <div class="progress_step_div"></div>
                    </div>
                </div>
            </div>
        </section>
            <section class="checkout-section" v-if="active_el==1">
                <div class="checkoutb_wrap">
                    <div class="checkoutb_div">
                        <div class="upsell_wrap">
                            <div class="upsell-header-div">
                                <div class="text-block-1181">Improve Results.<br>Eliminate Side Effects.</div>
                                <p class="paragraph-15-14">Supercharge your results with instant nausea relief for less than an insurance copay.</p>
                            </div>                            
                            <div class="product-upsell-div desk checkout">
                                <div class="item-text-div checkout">
                                    <div class="item-details-div upsell">
                                        <div class="upsell-img-div"><img src="@/assets/images/PM_Zorfran-SQ.png"  loading="lazy" width="178" sizes="(max-width: 479px) 100vw, 133.9140625px" alt="" srcset="@/assets/images/PM_Zorfran-SQ.png 500w, @/assets/images/PM_Zorfran-SQ.png 800w, @/assets/images/PM_Zorfran-SQ.png 1080w"></div>
                                        <div class="upsell_boxinfo upsell">
                                            <div class="upsellboxtop_div">
                                                <div class="mobile_img_div"><img src="@/assets/images/PriMeds_Pills_Zofram.png" loading="lazy" sizes="(max-width: 479px) 8vw, 100vw" srcset="@/assets/images/PriMeds_Pills_Zofram.png 500w, @/assets/images/PriMeds_Pills_Zofram.png 600w" alt="" class="mobile-image zofram"></div>
                                                <div class="upsell_top_info_div">
                                                    <div class="reco-box-top upsell">
                                                        <div class="div-block-1743"><img src="@/assets/images/icon_-RX-black.svg" loading="lazy" alt="" class="image-408 upsell">
                                                            <div class="text-block-790">Prescription</div>
                                                        </div>
                                                        <div class="category-text upsell">WEIGHT LOSS</div>
                                                    </div>
                                                    <div class="item-name-price-div upsell">
                                                        <div class="item-name-side">
                                                            <div class="productname upsell">GLP Anti-Nausea</div>
                                                            <div class="text-block-959">{{90 * paymentTerms}} Day Supply. {{30 * paymentTerms}} 4mg Pills</div>
                                                        </div>
                                                        <div class="price-side">
                                                            <div class="old-price">
                                                                <div class="item-price-div">
                                                                    <div class="dollar-sign">$</div>
                                                                    <div class="price old upsell">{{74 * paymentTerms}}</div><img src="@/assets/images/discount-x-01.png" loading="lazy" width="122" sizes="(max-width: 479px) 24.4765625px, 34.484375px" alt="" srcset="@/assets/images/discount-x-01-p-500.png 500w, @/assets/images/discount-x-01-p-800.png 800w, @/assets/images/discount-x-01-p-1080.png 1080w, @/assets/images/discount-x-01-p-1600.png 1600w, @/assets/images/discount-x-01-p-2000.png 2000w, @/assets/images/discount-x-01-p-2600.png 2600w, @/assets/images/discount-x-01-p-3200.png 3200w, @/assets/images/discount-x-01.png 3912w" class="image-450">
                                                                </div>
                                                            </div>
                                                            <div class="discount-price">
                                                                <div class="item-price-div">
                                                                    <div class="dollar-sign">$</div>
                                                                    <div class="price upsell">{{19.97 * paymentTerms}}</div>
                                                                </div>
                                                                <div class="text-block-962"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="upsell_boxbullets_div">
                                                <div class="list-flex-div">
                                                    <ul role="list" class="list-10">
                                                        <li>
                                                            <div class="checkout_upsellbullet_text">Instant Nausea Relief</div>
                                                        </li>
                                                    </ul>
                                                    <ul role="list" class="list-10">
                                                        <li>
                                                            <div class="checkout_upsellbullet_text">Works in Minutes</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <a href="#" @click.prevent="setMedSelected('Nausea')" class="upsell_boxbutton solo w-button">ADD TO ORDER</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="upsell-button-div">
                                <a href="#" @click.prevent="moveToNext()" class="button-113 w-button" style="color:#fff"><strong>&quot;I&#x27;m Not Interested in Eliminating My Side Effects&quot;</strong> <span class="text-span-254">-&gt;</span></a>
                            </div>
                            <div class="w-form-fail" style="display:block" v-if="showError">
                              <div>{{errorMessage}} </div>
                          </div>
                        </div>
                    </div>
                </div>
            </section>
        <!-- step 2 of the page -->
        
    </div>
    </template>
    <script>
    
    import { mapGetters } from 'vuex';
    export default {
        name: 'paymentThanks',
        props: ['baseUrl', 'stripeKey', 'googleMapsApiKey'],
        data() {
            return {
                active_el: 1,
                selectedOption:'',
                selectedMedBundleId:"",
                submitting: false,
                showError: false,
                errorMessage: '',
                
            }
        },
        computed:{
            ...mapGetters(['getRemainingPrescriptions','user']),
            remainingPrescriptions() {
                return this.getRemainingPrescriptions;
            },
            getDrugName(){
                return this.selectedOption === '' ? 'GLP Anti-Nausea and GLP Energy' : this.selectedOption === 'B12' ? 'GLP Anti-Nausea' : 'GLP Energy'
            },
            getProductName(){
                return JSON.parse(localStorage.getItem("planName"))
            },
            paymentTerms() {
                  let temp = this.$route.query.terms ? Number(this.$route.query.terms) || 1 : 1;
                  if(temp==6 || temp==3){
                      return temp/3;
                  }
                  return 1;
              }
        },
        watch: {
            active_el() {
                window.scrollTo(0, 0)
            }
        },
        methods:{
          integerPart(value) {
              return Math.floor(value); // Extracts the whole number part
          },
          decimalPart(value) {
              const decimalStr = (value % 1).toFixed(2).split('.')[1]; 
              return decimalStr || '00'; // Ensures two decimal places
          },
            setMedSelected(value){
                this.selectedOption = value;
                this.selectedMedBundleId= "695ea10f212aecbe412f3ab9"
                this.moveToNext();
            },
            moveToNext(){
                this.addBundleAndMove();
            },
            async addBundleAndMove() {
                try {
                    this.submitting = true;
                    this.showError= false;
                    const response = await this.$axios.post(`${this.baseUrl}/api/bundle-selected`, {
                        selectedMed: this.selectedOption || "None",
                        selectedMedBundleId: this.selectedMedBundleId || "None",
                        terms: 3
                    });

                    if (response.data.status === "success") {

                        try{
                            window.tracking.event('purchase', {value: response.data.totalAmount, currency: 'USD'});
                        }catch(error){
                            console.log(error)
                        }
                        this.$router.push({
                            name: "showStepsToUser"
                        });
                    } else {
                        this.$router.push({
                            name: "showStepsToUser"
                        });
                    }
                } catch (error) {
                    this.$router.push({
                            name: "showStepsToUser"
                        });
                }
            },
            async fireGTM() {
                try {
                    const amount = this.$route.query.amount;
                    const transid = this.$route.query.trans_id;
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'purchase',
                        'ecommerce': {
                            'transaction_id': transid,
                            'value': amount,
                            'currency': 'USD',
                        }
                    });
                    console.log(":white_check_mark: Google pixel fired with amount:", amount);
                } catch (error) {
                    console.error(":x: Error firing Google pixel:", error);
                }
                
            },
            pushToMedForm(){
              this.$router.push({
                        name: 'verifyPhoneAndEmail'
              });
            }
        },
        mounted(){
            this.fireGTM();
            
        }
    }
    </script>
    <style scoped>
    .selected-plan-img{
        width: 45px;
    }
    </style>